import React from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'

const countVisitors = async ({ page }) => {
    const cancelToken = axios.CancelToken.source()

    await axios.post('https://www.thewordartisan.online/api/v1/click/clicks',
    {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Content-Type": "application/json",
        },
        page
    },
    {
        cancelToken: cancelToken.token
    })

    .catch((err) => {
        if (axios.isCancel(err)) {
            console.log('Axios post cancelled.');
        } else {
            console.log(err);
        }
    })
}

export default countVisitors